export function getImageUrl(imageName: string) {
  return `${process.env.PUBLIC_URL}/images/${imageName}`;
}
